import React, { Suspense } from "react";
import { Box, CircularProgress, useTheme } from "@mui/material";

const JsCodeEditor = React.lazy(() => import("../codeEditor/JsCodeEditor"));
const HtmlCodeEditor = React.lazy(() => import("../codeEditor/HtmlCodeEditor"));
const PythonCodeEditor = React.lazy(() => import("../codeEditor/PythonCodeEditor"));
const SqlCodeEditor = React.lazy(() => import("../codeEditor/SqlCodeEditor"));

export default function DynamicCodeEditor({ language, initialCode }) {
  const theme = useTheme();
  const lang = language?.toLowerCase();

  const renderEditor = () => {
    switch (lang) {
      case "javascript":
        return <JsCodeEditor initialCode={initialCode} />;
      case "html":
        return <HtmlCodeEditor initialCode={initialCode} />;
      case "fastapi":
        return <PythonCodeEditor initialCode={initialCode} runnable={false} />;
      case "agenticai":
      case "agentic-ai":
        return <PythonCodeEditor initialCode={initialCode} runnable={false} />;
      case "dsa":
        return <PythonCodeEditor initialCode={initialCode} runnable={false} />;
      case "python":
        return <PythonCodeEditor initialCode={initialCode} runnable={true} />;
      case "css":
        return <HtmlCodeEditor initialCode={initialCode} />;
      case "sql":
        return <SqlCodeEditor initialCode={initialCode} hideOutput={false} />;
      default:
        return (
          <Box
            component="pre"
            sx={{
              backgroundColor:
                theme.palette.mode === "dark"
                  ? "rgba(255,255,255,0.05)"
                  : theme.palette.grey[100],
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.text.primary
                  : "#1a1a1a",
              p: 2,
              borderRadius: 2,
              fontFamily: "'Fira Code', monospace",
              fontSize: "0.95rem",
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              overflow: "visible",
              height: "auto",
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            }}
          >
            <code>{initialCode}</code>
          </Box>
        );
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        my: 2,
        borderRadius: 2,
        overflow: "visible",
      }}
    >
      <Suspense
        fallback={
          <Box sx={{ textAlign: "center", p: 2 }}>
            <CircularProgress size={24} />
          </Box>
        }
      >
        {renderEditor()}
      </Suspense>
    </Box>
  );
}
